import React from 'react'
import './tiendas.css'
import lg_amazon from '../../../assets/imgs/libro_verde/amazon_logo 1.png'
import lg_google from '../../../assets/imgs/libro_verde/Google_Play_Logo 1.png'
import lg_spotify from '../../../assets/imgs/libro_verde/Spotify_logo 1.png'
import lg_gandhi from '../../../assets/imgs/libro_verde/gandhi_logo.png'
import lg_sotano from '../../../assets/imgs/libro_verde/El_Sotano_Logo 1.png'
import lg_porrua from '../../../assets/imgs/libro_verde/Porrua_logo 1.png'
import lg_gonvill from '../../../assets/imgs/libro_verde/Gonvill_logo 1.png'
import lg_sanborns from '../../../assets/imgs/libro_verde/Sanborns_Logo 1.png'
import { useTranslation } from "react-i18next";

const Tiendas = () => {
    const [t, i18n] = useTranslation("librVerd");
  return (
    <div class="NLV_tiendas_bg">
        <div class="NLV_tiendas">
            <div class="NLV_tiendas_librerias">
                <h2>{(t('tiendas.librerias'))}</h2>
                <div class="NLV_tiendas_img">
                <a href='https://www.gandhi.com.mx/ideas-que-transforman-sociedades-para-cambiar-al-mundo' target='_blank' rel="noreferer" className={"imagen"}>
                        <img class="imagen" src={lg_gandhi} alt="Imagen 1" />
                        </a>

                        <a href='https://www.elsotano.com/libro/ideas-que-transforman-sociedades-para-cambiar-al-mundo_10632778' target='_blank' rel="noreferer" className={"imagen"}>
                        <img class="imagen" src={lg_sotano} alt="Imagen 1" />
                        </a>

                        <a   rel="noreferer" className={"imagen"}>
                        <img class="imagen" src={lg_porrua} alt="Imagen 1" />
                        </a>

                        <a   rel="noreferer" className={"imagen"}>
                        <img class="imagen" src={lg_gonvill} alt="Imagen 1" />
                        </a>

                        <a rel="noreferer" className={"imagen"}>
                        <img class="imagen" src={lg_sanborns} alt="Imagen 1" />
                        </a>
                </div>
            </div>
            <div class="NLV_tiendas_audio">
                <h2>{(t('tiendas.audiolibro'))}</h2>
                <div class="NLV_tiendas_img">
                    <a href='https://open.spotify.com/show/4J2DorWHvWqzL0zelMScOy' target="_blank" rel="noreferer" className={"imagen"}>
                        <img class="imagen" src={lg_spotify} alt="Imagen 1" />
                        </a>
                </div>
            </div>
            <div class="NLV_tiendas_ebook">
                <h2>{(t('tiendas.ebook'))}</h2>
                <div class="NLV_tiendas_img">
                <a href='https://www.amazon.com.mx/Ideas-transforman-sociedades-cambiar-mundo-ebook/dp/B0BCBW47SP/ref=tmm_kin_swatch_0?_encoding=UTF8&qid=&sr='  target="_blank"  rel="noreferer" className={"imagen"}>
                        <img class="imagen" src={lg_amazon} alt="Imagen 1" />
                        </a>
                        <a href='https://play.google.com/store/books/details?id=Op-aEAAAQBAJ&pli=1'  target="_blank"  rel="noreferer" className={"imagen"}>
                        <img class="imagen" src={lg_google} alt="Imagen 1" />
                        </a>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Tiendas
